var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grafico" },
    [
      _c("Bar", {
        attrs: {
          chartData: _vm.arrTeste,
          chartData2: _vm.arrTeste2,
          options: _vm.options,
          label: "Rentabilidade acumulada",
          label2: "Rentabilidade mensal"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }